import { Checkout, Tag, defaultImage } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './item-checkouted.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  checkout: Checkout
}

export default ({ className = '', style = {}, checkout }: Props) => {
  const [t, i18n] = useTranslation('engage')

  const parseIconByStatus = (status: string) => {
    switch (status) {
      case 'requested':
        return 'fa-solid fa-circle-pause'
      case 'approved':
        return 'fa-solid fa-circle-check'
      case 'reproved':
        return 'fa-solid fa-circle-xmark'
      default:
        return 'fa-solid fa-circle-info'
    }
  }

  const parseColorByStatus = (status: string) => {
    switch (status) {
      case 'requested':
        return 'gold'
      case 'approved':
        return 'green'
      case 'reproved':
        return 'red'
      default:
        return 'gray'
    }
  }

  if (!checkout) {
    return null
  }

  return (
    <div className={`item-checkouted ${className}`} style={style}>
      <header>
        <figure>
          <img
            src={checkout.prize?.image?.thumbnail}
            className="img-fluid"
            title={checkout.prize?.value}
            alt={checkout.prize?.value}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = defaultImage
            }}
          />
        </figure>
        <div className="texts">
          <h6>{checkout.prize?.value}</h6>
          <div className="tags">
            <Tag
              labels={[
                <strong>
                  -{checkout?.prize?.points} {t('points')}
                </strong>,
              ]}
              separator
            />
            <Tag
              icon={<i className="fa-regular fa-calendar"></i>}
              labels={[
                <div>
                  {t('checkoutsPage.date')} <strong>{new Date(checkout?.createdAt).toLocaleDateString(i18n.language)}</strong>
                </div>,
              ]}
              separator
            />
          </div>
        </div>
      </header>
      <p>{t(`checkoutsPage.statusText.${checkout.status}`)}</p>
      <footer>
        <i className={`${parseColorByStatus(checkout.status)} ${parseIconByStatus(checkout.status)}}`}></i>
        {t('status')}: <strong>{t(`checkoutsPage.status.${checkout.status}`)}</strong>
        {checkout.status !== 'requested' && (
          <div>
            {' '}
            {t('checkoutsPage.updatedAt')} <strong>{new Date(checkout?.createdAt).toLocaleDateString(i18n.language)}</strong>
          </div>
        )}
      </footer>
    </div>
  )
}
